import React, { useState, useEffect, CSSProperties } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import "jquery-confirm/css/jquery-confirm.css";
import "jquery-confirm";


// Define the DataTableProps interface
interface DataTableProps {
  headers: {
    key: string;
    label: string;
    sortable?: boolean;
    items?: any;
    style?: any;
    isNumeric?: boolean;
  }[];
  rows?: any[];
  onAction?: (action: string, row: any) => void;
  onSortAction?: (row: any, action?: string) => void;
  onFileAction?: (action: string, row: any) => void;
  onDownloadAction?: (action: string, row: any) => void;
  isLogTable?: boolean;
  isTodayAppointmentTable?: boolean;
  isUpcomingAppointmentTable?: boolean;
  isPastAppointmentTable?: boolean;
  radioSelection?: boolean;
  onRadioSelect?: (row: any) => void; // ✅ This line
  onRowSelect?: (row: any) => void;
  selectedRow?: any;
  selectedRowRadio?: any;
  isCheckbox?: boolean;
  onCheckboxSelect?: (selectedRows: any[]) => void;
  selectedRowIds?: any;
  disabled?: boolean;
}

const DataTableForMultiAppointment: React.FC<DataTableProps> = ({
  headers,
  rows = [],
  onAction,
  onSortAction,
  onFileAction,
  onDownloadAction,
  isLogTable = false,
  isTodayAppointmentTable,
  isUpcomingAppointmentTable,
  isPastAppointmentTable,
  radioSelection = false,
  onRadioSelect,
  onRowSelect,
  selectedRow,
  isCheckbox = false,
  onCheckboxSelect,
  selectedRowIds = [],
  disabled = false,
}) => {
  const [sortedRows, setSortedRows] = useState<any[]>(rows);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [selectAll, setSelectAll] = useState(false);

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ASC" | "DESC" | null;
  }>({
    key: "",
    direction: null,
  });

  const tableStyle = {
    border: "1px solid #ddd",
    borderCollapse: "collapse" as const,
    width: "100%",
    tableLayout: "fixed",
  };

  const thStyle: CSSProperties = {
    border: "none",
    padding: "8px",
    backgroundColor: "#e0f7fa",
    color: "#000",
    cursor: "pointer",
    position: "sticky", // ✅ This will now work correctly
    top: 0,
    zIndex: -90,
  };

  const tdStyle = {
    border: "none",
    padding: "8px",
  };

  const handleSort = (key: string, direction: "ASC" | "DESC") => {
    if (sortConfig.key === key && sortConfig.direction === direction) {
      return; // Prevent clicking on the same active sort direction
    }
    const sorted = [...sortedRows].sort((a, b) => {
      if (direction === "ASC") {
        return a[key] > b[key] ? 1 : -1;
      }
      if (direction === "DESC") {
        return a[key] < b[key] ? 1 : -1;
      }
      return 0;
    });

    setSortedRows(sorted);
    setSortConfig({ key, direction });
    onSortAction?.({ key, direction });
  };

  useEffect(() => {
    if (
      isCheckbox &&
      rows?.length > 0 &&
      selectedRowIds?.length > 0 &&
      Array.isArray(selectedRowIds)
    ) {
      const cleanedIds = selectedRowIds?.map((id: string) => id?.trim());
      const selectedIdSet = new Set(cleanedIds);

      const selected = rows?.filter((row) => selectedIdSet.has(String(row.id)));

      const unselected = rows?.filter(
        (row) => !selectedIdSet.has(String(row.id))
      );

      const ordered = [...selected, ...unselected];

      setSelectedRows(selected);
      const allSelected = rows?.length > 0 && selected?.length === rows?.length;
      setSelectAll(allSelected);
    } else {
      setSortedRows(rows || []);
      setSelectedRows([]);
    }
  }, [rows]);

  const handleSelectAll = () => {
    const newSelectAll = !selectAll;
    const updated = newSelectAll ? [...sortedRows] : [];
    setSelectedRows(updated);
    setSelectAll(newSelectAll);
    onCheckboxSelect?.(updated);
  };

  const handleCheckboxChange = (row: any) => {
    const isSelected = selectedRows.some((r) => r.id === row.id);
    const updated = isSelected
      ? selectedRows.filter((r) => r.id !== row.id)
      : [...selectedRows, row];
    setSelectedRows(updated);
    setSelectAll(updated.length === sortedRows.length);
    onCheckboxSelect?.(updated);
  };

  const [showModal, setShowModal] = useState(false);
  const [instructionsData, setInstructionsData] = useState<any[]>([]);

  const handleOpenModal = (dataString: string) => {
    try {
      const parsedData = JSON.parse(dataString);
      setInstructionsData(parsedData);
    } catch (e) {
      console.error("Invalid JSON for splInstructions", e);
      setInstructionsData([]);
    }
    setShowModal(true);
  };

  return (
    <>
      <div className="table-responsive border-0 mb-2">
        <Table style={{ tableLayout: "fixed" }}>
          <thead>
            <tr>
              {radioSelection && <th style={{ width: "5%" }} />}

              {isCheckbox && (
                <th style={{ width: "5%", textAlign: "center" }}>
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    disabled={disabled}
                  />
                </th>
              )}

              {headers.map((header) => (
                // <th key={header.key} style={thStyle}>
                <th
                  key={header.key}
                  style={{
                    border: "none",
                    padding: "8px",
                    backgroundColor: "#e0f7fa",
                    color: "#000",
                    cursor: header.sortable ? "pointer" : "default",
                    position: "sticky",
                    top: 0,
                    zIndex: -90,

                    textAlign: [
                      "isActiveDetails",
                      "appointmentStatusDesc",
                      "actions",
                      "phonenumber",
                      "download",
                    ].includes(header.key)
                      ? "center"
                      : "left",
                    ...header.style,
                  }}
                >
                  <div
                    style={{
                      display: [
                        "isActiveDetails",
                        "appointmentStatusDesc",
                        "actions",
                        "phonenumber",
                        "contactphonenumber",
                        "download",
                      ].includes(header.key)
                        ? "flex"
                        : "flex",

                      justifyContent: [
                        "isActiveDetails",
                        "appointmentStatusDesc",
                        "actions",
                        "phonenumber",
                        "contactphonenumber",
                        "download",
                        "downloads",
                      ].includes(header.key)
                        ? "space-evenly"
                        : "space-between",

                      alignItems: "center",
                    }}
                  >
                    <span>{header.label}</span>
                    {header.sortable && (
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          marginLeft: "4px",
                          cursor: "pointer",
                          position: "absolute",
                          right: "0px",
                        }}
                      >
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "ASC"
                        ) && (
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "18px",
                              lineHeight: "10px",
                            }}
                            onClick={() => handleSort(header.key, "ASC")}
                          >
                            arrow_drop_up
                          </span>
                        )}
                        {!(
                          sortConfig.key === header.key &&
                          sortConfig.direction === "DESC"
                        ) && (
                          <span
                            className="material-icons"
                            style={{
                              fontSize: "18px",
                              lineHeight: "10px",
                            }}
                            onClick={() => handleSort(header.key, "DESC")}
                          >
                            arrow_drop_down
                          </span>
                        )}
                      </span>
                    )}
                  </div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedRows?.length > 0 ? (
              sortedRows.map((row, index) => (
                <tr
                  key={row.id}
                  style={{
                    backgroundColor: index % 2 === 1 ? "white" : "#f2f2f2",
                  }}
                >
                  {radioSelection && (
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="radio"
                        name="rowSelect"
                        checked={
                          selectedRow?.original?.scheduleId ===
                          row.original?.scheduleId
                        }
                        onChange={() => {
                          onRadioSelect?.(row); // ✅ Call the prop
                        }}
                      />
                    </td>
                  )}

                  {isCheckbox && (
                    <td style={{ textAlign: "center" }}>
                      <input
                        type="checkbox"
                        checked={selectedRows.some((r) => r.id === row.id)}
                        onChange={() => handleCheckboxChange(row)}
                        disabled={disabled}
                      />
                    </td>
                  )}

                  {headers.map((header) => {
                    if (header.key === "isActiveDetails") {
                      return (
                        <td
                          key={header.key}
                          className="text-center"
                          style={{
                            color:
                              row.isActiveDetails === "Yes"
                                ? "#0d6efd"
                                : "#EE3339",
                            textAlign: "center",
                          }}
                        >
                          {row.isActiveDetails}
                        </td>
                      );
                    }

                    if (header.key === "appointmentStatusDesc") {
                      return (
                        <td
                          key={header.key}
                          className="text-center"
                          style={{
                            textAlign: "center",
                          }}
                        >
                          {row.appointmentStatusDesc}
                        </td>
                      );
                    }

                    if (header.key === "fileAction") {
                      return (
                        <td key={header.key} style={{ padding: "8px" }}>
                          {row.fileAction && (
                            <>
                              <span
                                className="attachfile d-inline-flex align-items-center"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  onFileAction?.(row, "fileAction")
                                }
                                role="button"
                              >
                                <span className="material-icons mx-1 color_brand text-dark">
                                  attachment
                                </span>
                                {row.fileAction}
                              </span>
                            </>
                          )}
                        </td>
                      );
                    }
                    if (header.key === "fileCount") {
                      return (
                        <td key={header.key} style={{ padding: "8px" }}>
                          {row.fileCount === 0 ? (
                            "-"
                          ) : (
                            <span className="attachfile">
                              <span
                                className="material-icons mx-1 color_brand text-dark"
                                style={{ cursor: "pointer" }}
                              >
                                attachment
                              </span>
                              {row.fileCount}
                            </span>
                          )}
                        </td>
                      );
                    }

                    if (header.key === "download") {
                      return (
                        <td key={header.key} style={{ padding: "8px" }}>
                          {row.download && (
                            <span
                              className="material-icons color_brand"
                              onClick={() =>
                                onDownloadAction?.(row, "download")
                              }
                              style={{ cursor: "pointer" }}
                            >
                              download
                            </span>
                          )}
                        </td>
                      );
                    }
                    if (header.key === "downloads") {
                      return (
                        <td key={header.key} style={{ padding: "8px" }}>
                          {row.download && row.status != "Cancelled" && (
                            <span
                              className="material-icons color_brand"
                              onClick={() =>
                                onDownloadAction?.(row, "download")
                              }
                              style={{ cursor: "pointer" }}
                            >
                              download
                            </span>
                          )}
                        </td>
                      );
                    }
                    if (header.key === "activityDescription") {
                      return (
                        <td key={header.key} style={{ padding: "8px" }}>
                          <OverlayTrigger
                            placement="auto"
                            delay={{ show: 200, hide: 10 }}
                            overlay={
                              <Tooltip
                                id={`view-tooltip-${row.id}`}
                                style={{ backgroundColor: "#b3e0ff" }}
                              >
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: row.activityDescription || "",
                                  }}
                                />
                              </Tooltip>
                            }
                          >
                            <span
                              style={{
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                width: "87%",
                                display: "inline-block",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: row.activityDescription || "",
                              }}
                            />
                          </OverlayTrigger>
                        </td>
                      );
                    }

                    if (header.key === "sourceType") {
                      return (
                        <td key={header.key} style={{ padding: "8px" }}>
                          {row.sourceType === "Notes" ? (
                            <span
                              style={{
                                color: "#1976d2",
                                border: "1px solid #0092d5",
                                borderRadius: "10%",
                                padding: "10px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "25px",
                                height: "25px",
                                fontSize: "18px",
                              }}
                              title="Notes"
                              className="material-symbols-outlined"
                            >
                              draw
                            </span>
                          ) : row.sourceType === "Activity" ? (
                            <span
                              style={{
                                color: "#d32f2f",
                                border: "1px solid #dc3545",
                                borderRadius: "10%",
                                padding: "10px",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: "25px",
                                height: "25px",
                                fontSize: "18px",
                              }}
                              title="Activity"
                              className="material-symbols-outlined"
                            >
                              manage_history
                            </span>
                          ) : null}
                        </td>
                      );
                    }

                    if (header.key === "providerAddressLocation") {
                      const cellContent = row[header.key];
                      return (
                        <td
                          key={header.key}
                          style={{ padding: "8px", textAlign: "left" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              gap: "8px",
                            }}
                          >
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                cellContent && cellContent?.length > 15 ? (
                                  <Tooltip
                                    id={`tooltip-${header.key}-${row.id}`}
                                    style={{ backgroundColor: "#b3e0ff" }}
                                  >
                                    {cellContent}
                                  </Tooltip>
                                ) : (
                                  <></>
                                )
                              }
                            >
                              <span
                                className="d-inline-block text-truncate"
                                style={{
                                  maxWidth: "calc(100% - 28px)", // leave space for icon
                                  cursor: "pointer",
                                }}
                              >
                                {cellContent}
                              </span>
                            </OverlayTrigger>

                            <span
                              className="material-symbols-outlined"
                              style={{ cursor: "pointer", color: "#007bff" }}
                              onClick={() =>
                                onDownloadAction?.(row, "download")
                              }
                            >
                              location_on
                            </span>
                          </div>
                        </td>
                      );
                    }

                    if (header.key === "specialInstructions") {
                      return (
                        <td key={header.key} style={{ textAlign: "center" }}>
                          <span
                            className="material-symbols-outlined"
                            style={{
                              cursor: "pointer",
                              color: "#f39c12",
                              fontSize: "20px",
                            }}
                            onClick={() => handleOpenModal(row[header.key])}
                          >
                            info
                          </span>
                        </td>
                      );
                    }

                    if (header.key === "actions") {
                      return (
                        <td
                          key={header.key}
                          style={{ padding: "8px", textAlign: "center" }}
                        >
                          {row.actions?.View && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                <Tooltip
                                  id={`view-tooltip-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  View
                                </Tooltip>
                              }
                            >
                              <span
                                className="material-icons color_brand"
                                onClick={() => onAction?.(row, "View")}
                                style={{ cursor: "pointer" }}
                              >
                                visibility
                              </span>
                            </OverlayTrigger>
                          )}
                          {row.actions?.Edit && (
                            <OverlayTrigger
                              placement="auto"
                              delay={{ show: 200, hide: 10 }}
                              overlay={
                                <Tooltip
                                  id={`edit-tooltip-${row.id}`}
                                  style={{ backgroundColor: "#b3e0ff" }}
                                >
                                  Edit
                                </Tooltip>
                              }
                            >
                              <span
                                className="material-icons color_brand"
                                onClick={() => onAction?.(row, "Edit")}
                                style={{ cursor: "pointer" }}
                              >
                                edit
                              </span>
                            </OverlayTrigger>
                          )}
                        </td>
                      );
                    }
                    if (header.key === "caseIdName" && row.isRead == "0") {
                      return (
                        <td
                          key={header.key}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span onClick={() => onAction?.(row, "CaseIdClick")}>
                            {row.caseIdName}
                          </span>
                          <img
                            src="/foldergif.gif"
                            height="38px"
                            width="38px"
                            alt="Folder"
                            style={{ float: "right", marginRight: "10px" }}
                          />
                        </td>
                      );
                    }

                    const cellContent = row[header.key];
                    return (
                      <td
                        key={header.key}
                        style={{
                          padding: header.isNumeric
                            ? "8px 20px 8px 8px !important"
                            : "8px",
                          textAlign: header.isNumeric ? "center" : "left",
                        }}
                      >
                        <OverlayTrigger
                          placement="auto"
                          delay={{ show: 200, hide: 10 }}
                          overlay={
                            cellContent &&
                            cellContent?.length > (isLogTable ? 60 : 15) ? (
                              <Tooltip
                                id={`tooltip-${header.key}-${row.id}`}
                                style={{ backgroundColor: "#b3e0ff" }}
                              >
                                {cellContent}
                              </Tooltip>
                            ) : (
                              <></>
                            )
                          }
                        >
                          <span
                            // className= 'd-inline-block text-truncate'
                            className={`d-inline-block ${
                              !isLogTable ? "text-truncate" : ""
                            }`}
                            style={{
                              maxWidth: isLogTable ? "none" : "100%",
                              cursor: isLogTable ? "default" : "pointer",
                            }}
                          >
                            {cellContent}
                          </span>
                        </OverlayTrigger>
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={headers?.length} style={{ textAlign: "center" }}>
                  <span className="no_rec_data">
                    {" "}
                    {isTodayAppointmentTable
                      ? "No Appointments Scheduled for Today"
                      : isUpcomingAppointmentTable
                      ? "No Appointments Scheduled"
                      : isPastAppointmentTable
                      ? "No Appointments"
                      : "No Record Found"}
                  </span>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    </>
  );
};

export default DataTableForMultiAppointment;
